import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { localStorageGet } from '@/helpers/localStorage'

import en from './locales/en.json'
import ru from './locales/ru.json'

Vue.use(VueI18n)

const SNG_LOCALES_START = [
  'ru', // Russia
  'uk', // Ukraine
  'be', // Belarus
  'kk', // Kazakhstan
  'ka', // Georgia
  'ro', // Moldova
  'uz', // Uzbekistan
  'tg', // Tajikistan
]

const DEFAULT_LOCALE = SNG_LOCALES_START.some(lang =>
  navigator.language.includes(lang),
)
  ? 'ru'
  : 'en'

const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: 'ru',
  messages: {
    en,
    ru,
  },
})

export const setCurrentLocale = (locale?: string): void => {
  try {
    const currentLocale = locale || localStorageGet('language')
    if (i18n.availableLocales.includes(currentLocale)) {
      i18n.locale = currentLocale
    }
  } catch (e) {
    console.log('current locale not found')
  }
}

export default i18n
